<template>
    <!-- Modal Update Remove -->
    <b-modal id="modal-add-credit-card"
        centered
        :title="title"
        cancel-variant="link"
        :lazy="true"
        hide-footer
        ref="modalCreditCard">

        <div v-show="loading">
            <sau-spinner class="p-5"></sau-spinner>
        </div>
        <div v-show="! loading">
            <div class="wm-hide d-flex flex-wrap justify-between">
                <template v-for="(field, index) in fields">
                    <div :class="field.width" :key="index">
                        <label class="d-block">{{ field.display }}
                            <div :id="field.name" class="border-bottom p-2"></div>
                            <small class="text-danger">{{ field.event && field.event.error ? field.event.error.message : '&nbsp;' }}</small>
                        </label>
                    </div>
                </template>
                <small class="text-danger" v-if="stripeSetupError.length">{{ stripeSetupError }}</small>
            </div>
            <div class="text-right">
                <button class="btn btn-success py-1" @click="submit" :disabled="submitting">Add Credit Card <i class="far fa-spinner-third fa-spin" v-if="submitting" /></button>
            </div>
        </div>
    </b-modal>
</template>

<script>

export default {
    props: ['update', 'spk'],
    data() {
        return {
            stripe: {},
            intent: '',
            fields: [
                {
                    name: 'cardNumber',
                    display: 'Card Number',
                    event: null,
                    element: null,
                    width: 'w-100',
                    loaded: false,
                },
                {
                    name: 'cardExpiry',
                    display: 'Expiry',
                    event: null,
                    element: null,
                    width: 'w-2/5',
                    loaded: false,
                },
                {
                    name: 'cardCvc',
                    display: 'CVC',
                    event: null,
                    element: null,
                    width: 'w-2/5',
                    loaded: false,
                },
            ],
            stripeSetupError: '',
            submitting: false,
        }
    },

    mounted() {
        this.stripe = Stripe(this.spk);
        const stripeElements = this.stripe.elements();

        this.fields = this.fields.map(field => {
            field.element = stripeElements.create(field.name);
            return field;
        })

        this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
            this.stripeInit();
            this.getSetupIntent();
        })

        this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
            this.stripeTeardown();
        });
    },

    methods: {

        getSetupIntent() {
            this.getRequest('/api/billing/setup-card').then(response => {
                this.intent = response.data;
            }).catch(error => {
                if(error.response && error.response.status === 429) {
                    return this.displayRateLimited();
                }

                this.handleError(error.response.message);
            })
        },

        displayRateLimited() {
            this.modalHide('modalCreditCard');
            this.$swal({
                type: 'warning',
                title: 'Hold on...',
                text: 'You\'ve tried to add a credit card a few too many times. Please wait a bit and try again.',
            });
        },

        stripeInit() {
            this.fields.map(field => {
                field.element.mount(`#${field.name}`);
                field.element.on('change', event => { field.event = event });
                field.element.on('ready', event => { field.loaded = true });
            });
        },

        stripeTeardown() {
            this.fields = this.fields.map(field => {
                field.element.removeEventListener('change');
                field.element.removeEventListener('ready');
                field.element.unmount();
                field.loaded = false;
                return field;
            })
        },

        submit() {
            this.stripeSetupError = '';
            this.submitting = true;

            this.stripe.confirmCardSetup(this.intent, {
                payment_method: {
                    card: this.cardElement,
                    billing_details: {
                        name: `${this.userDetails.firstname} ${this.userDetails.lastname}`,
                        email: `${this.userDetails.email}`,
                    },
                },
            }).then(result => {

                if (result.error) {
                    this.stripeSetupError = result.error.message;
                    this.submitting = false;

                } else {
                    this.postRequest('/api/billing/confirm-card', { intent: result.setupIntent})
                        .then(response => {

                            this.setPaymentMethod('creditcard');
                            this.$swal({
                                type: 'success',
                                title: 'Credit Card Added',
                                showConfirmButton: false,
                                timer: 2500,
                            });
                        })
                        .catch(error => {
                            this.handleError(error.response.message);
                        })
                        .finally(() => {
                            this.submitting = false;
                            this.update();
                            this.modalHide('modalCreditCard');
                        });
                }

            }).catch(error => {
                this.submitting = false;
            });
        },

        handleError(mesage) {
            this.modalHide('modalCreditCard');

            this.$swal({
                type: 'error',
                text: message,
                showConfirmButton: false,
                toast: true,
                timer: 2500,
            });
        },
    },
    computed: {
        title() {
            return this.updating ? 'Update your Credit Card' : 'Add a Credit Card to your account'
        },
        loading() {
            return this.fields.filter(field => ! field.loaded).length > 0 || this.intent.length === 0;
        },
        cardElement() {
            return this.fields[0].element;
        },
    }
}
</script>
